import React, { FunctionComponent } from 'react';
import { PersonShowModalProps, PersonShowModalState } from './types';
import { PersonShowModalScout } from '../../molecules/personShowModalScout';
import { PersonShowModalScoutList } from '../../molecules/personShowModalScoutList';
import { PersonShowModalIntroduction } from '../../molecules/personShowModalIntroduction';
import { PersonShowModalHistories } from '../../molecules/personShowModalHistories';
import { PersonShowModalActivity } from '../../molecules/personShowModalActivity';
import { PersonShowModalSlogan } from '../../molecules/personShowModalSlogan';
import { PersonShowModalSkill } from '../../molecules/personShowModalSkill';
import { PersonShowModalInterest } from '../../molecules/personShowModalInterest';
import { PersonShowModalFavoriteBrand } from '../../molecules/personShowModalFavoriteBrand';
import { PersonShowModalMotivation } from '../../molecules/personShowModalMotivation';
import { PersonShowModalGender } from '../../molecules/personShowModalGender';
import { PersonShowModalGraduationYear } from '../../molecules/personShowModalGraduationYear';
import { PersonShowModalLocation } from '../../molecules/personShowModalLocation';
import { PersonShowModalPreferredLocations } from '../../molecules/personShowModalPreferredLocations';
import { PersonShowModalPreferredOccupations } from '../../molecules/personShowModalPreferredOccupations';
import { PersonShowModalPreferenceConditions } from '../../molecules/personShowModalPreferenceConditions';
import { PersonShowModalCurrentOccupations } from '../../molecules/personShowModalCurrentOccupations';
import { PersonShowModalSalary } from '../../molecules/personShowModalSalary';
import { PersonShowModalBirthday } from '../../molecules/personShowModalBirthday';
import { PersonShowModalResumes } from '../../molecules/personShowModalResumes';
import { PersonShowModalContacts } from '../../molecules/personShowModalContacts';
import { PersonPreferenceNotificationSettings } from '../../molecules/personPreferenceNotificationSettings';
import { GraduationList, JobResumeStates, OccupationItem, PreferredOccupationItem, ResumeStates, Salaries } from '../../../types/personShow';
import { FlashBox } from '../../atoms/flashBox';

type Props = PersonShowModalProps & {
  state: PersonShowModalState;
  flash: { flash: boolean; flashType: string; flashMessage: string };
  handleFlash: (flash: boolean, flashType: string, flashMessage: string) => void;
  onHandleOpenModal: () => void;
  onHandleUpdate: () => void;
  handleClear: () => void;
  registerCommitHandler: (key: string, handler: () => any) => void;
  registerValidationHandler: (key: string, handler: () => boolean) => void;
  onChangedText: (name: string, value: any) => void;
  uncompletes?: Array<{ name: string; id: string; }>;
  isLastIndex?: (index: number) => boolean;
};

export const Presentation: FunctionComponent<Props> = ({
  state,
  flash,
  handleFlash,
  isModal,
  isPc,
  resumeLoading,
  title,
  target,
  personId,
  scouts,
  entries,
  favorites,
  favoritesCounts,
  entriesCounts,
  scoutsCounts,
  type,
  scoutId,
  scoutTitle,
  scoutCreatedAt,
  scoutMessage,
  startYearList,
  endYearList,
  careerEmploymentTypes,
  birthdayList,
  birthdayListStart,
  educationalHistories,
  careerHistories,
  skills,
  interests,
  favoriteBrands,
  preferredLocations,
  preferredOccupations,
  currentOccupations,
  introduction,
  activity,
  slogan,
  motivation,
  gender,
  graduationYear,
  graduationList,
  location,
  tel,
  instagram,
  twitter,
  resume,
  job_resume,
  salary,
  salaries,
  birthday,
  clickTarget,
  onChangedBody,
  handleOpenModal,
  onHandleOpenModal,
  handleUpdate,
  onHandleUpdate,
  handleClear,
  registerCommitHandler,
  registerValidationHandler,
  handleDeleteHistories,
  uncompletes,
  isLastIndex,
}) => {
  const isWideField = ['introduction', 'slogan', 'activity', 'educationalHistories', 'careerHistories'].indexOf(target) !== -1;
  const isContactField = ['tel', 'instagram', 'twitter'].indexOf(target) !== -1;
  const isResumeField = ['resume', 'job_resume'].indexOf(target) !== -1;
  const hasSingleButton = ['educationalHistories', 'careerHistories', 'birthday'].indexOf(target) !== -1;
  // const isTallField = ['scout', 'gender', 'birthday', 'graduationYear', 'tel', 'instagram', 'twitter', 'activity', 'slogan', 'introduction', 'motivation'].indexOf(target) !== -1;
  const contacts: Record<'tel' | 'instagram' | 'twitter', string> = {
    tel: tel ?? '',
    instagram: instagram ?? '',
    twitter: twitter ?? '',
  };

  return (
    <>
      <FlashBox
        flash={flash.flash}
        flashType={flash.flashType}
        flashMessage={flash.flashMessage}
        handleFlash={handleFlash}
      />
      <div className={`person__show__modal ${isWideField ? 'is-wide' : ''} ${isModal ? 'active' : ''}`}>
        <div className="person__show__modal__wrapper">
          <h3 className="person__show__modal__title">
            <div onClick={onHandleOpenModal} className="mask">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z" fill="#19190F" />
              </svg>
            </div>
            <p className="title">{title}</p>
          </h3>

          {/* 各コンポーネント */}
          {target === 'scout' && (
            <PersonShowModalScout {...{ personId, title, target, scoutId: scoutId as number, scoutTitle: scoutTitle as string, scoutCreatedAt: scoutCreatedAt as string, scoutMessage: scoutMessage as string }} />
          )}
          {target === 'scoutList' && (
            <PersonShowModalScoutList {...{ personId, title, target, favoritesCounts: favoritesCounts as number, entriesCounts: entriesCounts as number, scoutsCounts: scoutsCounts as number, type: type as string }} />
          )}
          {target === 'introduction' && state.introduction !== undefined && (
            <PersonShowModalIntroduction {...{ body: state.introduction, target, onChangedBody: onChangedBody ?? (() => { }) }} />
          )}
          {target === 'educationalHistories' && state.educationalHistories !== undefined && (
            <PersonShowModalHistories {...{ histories: state.educationalHistories, target, onChangedBody: onChangedBody ?? (() => { }), clickTarget: clickTarget as number, startYearList: startYearList as number[], endYearList: endYearList as number[], birthdayList: birthdayList as number[], handleDeleteHistories: handleDeleteHistories ?? (() => { }) }} />
          )}
          {target === 'careerHistories' && state.careerHistories !== undefined && (
            <PersonShowModalHistories {...{ histories: state.careerHistories, target, onChangedBody: onChangedBody ?? (() => {}), clickTarget: clickTarget as number, startYearList: startYearList as number[], endYearList: endYearList as number[], birthdayList: birthdayList as number[], careerEmploymentTypes: careerEmploymentTypes, handleDeleteHistories: handleDeleteHistories ?? (() => {}), onRegisterValidationHandler: (handler) => registerValidationHandler('careerHistories', handler) }} />
          )}
          {target === 'activity' && state.activity !== undefined && (
            <PersonShowModalActivity {...{ body: state.activity, target, onChangedBody: onChangedBody ?? (() => { }) }} />
          )}
          {target === 'slogan' && state.slogan !== undefined && (
            <PersonShowModalSlogan {...{ body: state.slogan, target, onChangedBody: onChangedBody ?? (() => { }) }} />
          )}
          {target === 'skills' && state.skills !== undefined && (
            <PersonShowModalSkill {...{ skills: state.skills, target, onChangedBody: onChangedBody ?? (() => { }), onRegisterCommitHandler: (handler) => registerCommitHandler('skills', handler) }} />
          )}
          {target === 'interests' && state.interests !== undefined && (
            <PersonShowModalInterest {...{ interests: state.interests, target, onChangedBody: onChangedBody ?? (() => { }), onRegisterCommitHandler: (handler) => registerCommitHandler('interests', handler) }} />
          )}
          {target === 'favoriteBrands' && state.favoriteBrands !== undefined && (
            <PersonShowModalFavoriteBrand {...{ favoriteBrands: state.favoriteBrands, target, onChangedBody: onChangedBody ?? (() => { }), onRegisterCommitHandler: (handler) => registerCommitHandler('favoriteBrands', handler) }} />
          )}
          {target === 'motivation' && state.motivation !== undefined && (
            <PersonShowModalMotivation {...{ motivation: state.motivation, target, onChangedBody: onChangedBody ?? (() => { }) }} />
          )}
          {target === 'gender' && (
            <PersonShowModalGender {...{ gender: gender as string, target, onChangedBody: onChangedBody ?? (() => { }) }} />
          )}
          {target === 'graduationYear' && (
            <PersonShowModalGraduationYear {...{ graduationYear: graduationYear as string, graduationList: graduationList as GraduationList, target, onChangedBody: onChangedBody ?? (() => { }) }} />
          )}
          {target === 'location' && (
            <PersonShowModalLocation {...{ location: location as string, target, onChangedBody: onChangedBody ?? (() => { }) }} />
          )}
          {target === 'preferredLocations' && state.preferredLocations !== undefined && (
            <PersonShowModalPreferredLocations {...{ preferredLocations: state.preferredLocations, target, onChangedBody: onChangedBody ?? (() => { }) }} />
          )}
          {target === 'preferredOccupations' && (
            <PersonShowModalPreferredOccupations {...{ preferredOccupations: preferredOccupations as PreferredOccupationItem[], target, onChangedBody: onChangedBody ?? (() => {}), onRegisterValidationHandler: (handler) => registerValidationHandler('preferredOccupations', handler) }} />
          )}
          {target === 'preferenceConditions' && (
            <PersonShowModalPreferenceConditions {...{ preferenceConditions: state.preferenceConditions, target, onChangedBody: onChangedBody ?? (() => { }) }} />
          )}
          {target === 'currentOccupations' && (
            <PersonShowModalCurrentOccupations {...{ currentOccupations: currentOccupations as OccupationItem[], target, onChangedBody: onChangedBody ?? (() => {}), onRegisterValidationHandler: (handler) => registerValidationHandler('currentOccupations', handler) }} />
          )}
          {target === 'salary' && (
            <PersonShowModalSalary {...{ salary: salary as number, target, onChangedBody: onChangedBody ?? (() => { }), salaries: salaries as Salaries[] }} />
          )}
          {target === 'birthday' && birthday !== undefined && (
            <PersonShowModalBirthday {...{ birthday: state.birthday, target, onChangedBody: onChangedBody ?? (() => { }) }} />
          )}
          {isResumeField && (
            <PersonShowModalResumes {...{ target: target as 'resume' | 'job_resume', resume: resume as ResumeStates, job_resume: job_resume as JobResumeStates, isPc, deleted: state.deleted, loading: resumeLoading ?? false, onChangedBody: onChangedBody ?? (() => { }) }} />
          )}
          {isContactField && (
            <PersonShowModalContacts {...{ target: target as 'tel' | 'instagram' | 'twitter', body: contacts[target as 'tel' | 'instagram' | 'twitter'], motivation: motivation as string, isModal, onChangedBody: onChangedBody ?? (() => { }) }} />
          )}
          {target === 'notification_settings' && (
            <PersonPreferenceNotificationSettings {...{ personId: personId as number }} />
          )}
          {target === 'whatisrequest' && (
            <div className='person__show__modal__inner request'>
              <p className='person__show__modal__inner--title'>
                ・エントリー後、1週間以上を経過し、採用フェーズが進んでいない<br />
                ・プロフィールが十分に埋まっている<br />
                場合に、リマインドとしてリクエストを送信できます。<br /><br />
                対応リクエストとは別にメッセージは自由に送信できますので、選考状況を確認したい・連絡したい場合などは、ぜひご活用ください。
              </p>
              {uncompletes && uncompletes.length > 0 && (
                <div className="uncompletes-list">
                  <p className="uncompletes-list--title">未完成のプロフィール項目</p>
                  <ul>
                    {uncompletes.map((item, index) => (
                      <li key={item.id}>
                        {item.name}
                        {isLastIndex?.(index) === false && <strong className="devide">&nbsp;/&nbsp;</strong>}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
          {target !== 'whatisrequest' && target !== 'scout' && target !== 'scoutList' && target !== 'notification_settings' && (
            <div className={`person__show__modal__submit ${hasSingleButton ? 'single' : ''}`}>
              {!hasSingleButton && (
                <div className="btnCover">
                  <p onClick={handleClear} className="clear">すべてクリア</p>
                </div>
              )}
              <div className="btnCover">
                <button onClick={onHandleUpdate} className="submit">保存</button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div onClick={onHandleOpenModal} className={`person__show__modal--bg ${isModal ? 'active' : ''}`}></div>
    </>
  );
};
